// extracted by mini-css-extract-plugin
module.exports = {"root":"SignOff_root__sOzfs","topBorder":"SignOff_topBorder__UO6cu","title":"SignOff_title__Q_P4c","text":"SignOff_text___lwco"};